import { getDefaultSession } from '@inrupt/solid-client-authn-browser';
const session = getDefaultSession();
const defaultClientName = 'Solid-To-Do';
async function login(issuer) {
    await session.login({
        clientName: defaultClientName,
        oidcIssuer: issuer,
        redirectUrl: location.href
    });
}
async function logout() {
    if (session.info.isLoggedIn) {
        await session.logout();
        location.reload();
    }
}
await session.handleIncomingRedirect({
    restorePreviousSession: true,
    url: location.href
});
export { session, login, logout };
